module.exports = new __parcel__URL__("guide_game_text.6fafe460.png").toString();